var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgButtonProfile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.31561 14.2085L4.31327 14.3637L4.3992 14.4929C5.77791 16.5664 8.14112 17.9361 10.8156 17.9361C13.49 17.9361 15.8532 16.5664 17.2319 14.4929L17.3178 14.3637L17.3155 14.2085C17.3053 13.531 16.9566 12.9696 16.4868 12.5301C16.019 12.0926 15.3976 11.7419 14.7433 11.4685C13.4369 10.9226 11.879 10.6361 10.8156 10.6361C9.74729 10.6361 8.18934 10.9225 6.88387 11.4686C6.23012 11.742 5.60955 12.0928 5.14256 12.5305C4.67346 12.9701 4.32582 13.5314 4.31561 14.2085ZM1.31555 10.2361C1.31555 4.99223 5.57169 0.736084 10.8156 0.736084C16.0594 0.736084 20.3156 4.99223 20.3156 10.2361C20.3156 15.4799 16.0594 19.7361 10.8156 19.7361C5.57169 19.7361 1.31555 15.4799 1.31555 10.2361ZM14.3156 6.23608C14.3156 4.29994 12.7517 2.73608 10.8156 2.73608C8.87941 2.73608 7.31555 4.29994 7.31555 6.23608C7.31555 8.17223 8.87941 9.73608 10.8156 9.73608C12.7517 9.73608 14.3156 8.17223 14.3156 6.23608Z",
    fill: "black",
    stroke: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgButtonProfile);
export default __webpack_public_path__ + "static/media/buttonProfile.dd20d7cf72c2bc5b288350949562c173.svg";
export { ForwardRef as ReactComponent };